import { Box, Collapse, Flex, Link, useStyleConfig } from '@chakra-ui/react';
import { PropsWithChildren, useState } from 'react';

import { RegistryPackageDocsPage } from '@/graphql/upbound-graphql';
import ChevronIcon from '@/icons/ChevronIcon';

const getActiveStyles = (isActive: boolean) => {
  if (isActive) {
    return { color: 'purple.0' };
  }

  return {};
};

const DocsTreeExpander: React.FC<
  PropsWithChildren<{
    variant: 'root' | 'child';
    selectedPage: RegistryPackageDocsPage | undefined;
    title: string;
    titles: Array<string>;
  }>
> = ({ children, selectedPage, title, titles, variant }) => {
  const [{ isOpen }, setState] = useState({ isOpen: false });
  const styles = useStyleConfig('TreeLink', { variant });
  const activeStyles = getActiveStyles(titles.includes(selectedPage?.name || ''));

  return (
    <Box>
      <Link sx={{ ...styles, ...activeStyles }} onClick={() => setState({ isOpen: !isOpen })}>
        <Flex alignItems="center" justifyContent="center">
          <Box sx={activeStyles} mr="auto" noOfLines={2} fontWeight={600}>
            {title}
          </Box>
          <ChevronIcon
            sx={activeStyles}
            direction={isOpen ? 'down' : 'right'}
            size="sm"
            width="11px"
            height="11px"
            ml="12px"
          />
        </Flex>
      </Link>
      <Collapse in={isOpen} animateOpacity={false}>
        {children}
      </Collapse>
    </Box>
  );
};

export default DocsTreeExpander;
